// ObservabilityIdentity.tsx — SCALE-2
//
// Renders nothing. Its only job is to keep the error tracker's idea of
// "who" in sync with the signed-in session, so an issue in Sentry can
// answer the one question that decides whether it's a P0:
//
//   "Is this one studio, or is it everybody?"
//
// It attaches OPAQUE UUIDS ONLY — the Supabase auth user id and the
// org id. Never an email, never a studio name, never a plan label
// tied to a person. Those uuids mean nothing outside Orbit's own
// database, which is the point: the founder can pivot on them in the
// admin panel, and Sentry holds nothing identifying.
//
// See src/pages/Privacy.tsx §1 — automatic collection is scoped to
// security/troubleshooting metadata, and §3's sub-processor table,
// which the founder must extend before this is switched on in prod.
//
// Mounted once, inside AuthProvider, next to CreatorCastAssets.

import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useOrgId } from '@/hooks/useOrgId';
import { setObservabilityIdentity } from '@/lib/observability';

export function ObservabilityIdentity() {
  const { user } = useAuth();
  // `useOrgId` is a react-query hook over profiles.org_id — already
  // cached app-wide, so this adds no extra request.
  const { data: orgId } = useOrgId();

  useEffect(() => {
    setObservabilityIdentity(user?.id ?? null, orgId ?? null);
  }, [user?.id, orgId]);

  return null;
}

export default ObservabilityIdentity;
